/**
 * @ngdoc component
 * @name catalog.component:ItxProductCustomize
 * @description
 */

(function() {

    'use strict';

    var ItxProductCustomizeCmp = {
        bindings: {
            product: '<',
            productCustomizations: '<'
        },
        controller: ItxProductCustomizeCmpCtrl,
        templateUrl: 'product-customize.component.html'
    };
    
    angular.module('itxApp.catalog')
        .component('itxProductCustomize', ItxProductCustomizeCmp)

    ItxProductCustomizeCmpCtrl.$inject = [
        'itxAkamaiSvc',
        'ngDialog',
        'ItxShopCartFct',
        '$http',
        '$q',
        'ProductCustomizeService',
        'logger',
        'ItxTranslateSvc'
    ];

    function ItxProductCustomizeCmpCtrl(
        itxAkamaiSvc,
        ngDialog,
        ItxShopCartFct,
        $http,
        $q,
        ProductCustomizeService,
        logger,
        ItxTranslateSvc
    ) {

        var _this = this;
        _this.textMaxLength = 6;
        _this.textLength = 0;
        _this.textDateLength = 0;
        _this.formErrorMessage = false;
        _this.formErrorMessageValidation = false;
        _this.formErrorDateOnlyNumbers = false;
        _this.positionCanvas = {};
        _this.context = {};
        _this.idCanvas = 'canvasCustomize';
        _this.loading = true;
        _this.isDateCustomization = false;
        _this.tabInitial = true;
        _this.activeDots = false;
        _this.tabDate = false;
        _this.customizeTextDate = '';
        _this.oldCustomizeTextDate = '';

        _this.$onInit = function(){
            ProductCustomizeService.getBlacklist().then(function (res) {
                _this.blacklist = res;
            });

            logger.log('ProductCustomizations CMS -> ', _this.productCustomizations);
            logger.log('ProductCustomizations XMEDIA -> ', _this.product.activeDetail.xmedia);

            setTimeout(function(){
                //_this.context = document.getElementById(_this.idCanvas).getContext('2d');
                _this.widthImg = $('.md-customize-wrapper .image-panel-wrap').width();
                _this.activeFont = _this.productCustomizations.typographies[0];
                _this.activeColor = _this.productCustomizations.colors[0];
                _this.activeArea = _this.productCustomizations.areas[0];  
                _this.setImage();
            }, 100);

            _this.isDateCustomization = _this.product.state.xcustomizationDate;
            
            if(_this.productCustomizations.type === 'EMBROIDERY_BAG'){
                _this.activeDots = false;
            }
        };

        _this.onFontSelect = function(font) {
            _this.activeFont = font;
            _this.reloadCanvas();
        }

        _this.onColorSelect = function(color) {
            _this.activeColor = color;
            _this.reloadCanvas();
        }

        _this.onAreaSelect = function(area) {
            _this.activeArea = area;
            _this.reloadCanvas();
        }

        _this.textChange = function() {
            if(_this.customizeText && _this.customizeText.length > _this.textMaxLength){
                _this.customizeText = _this.customizeText.substring(0, _this.textMaxLength);
                _this.textLength = _this.customizeText.split('.').join('').length;
            }

            if(_this.charactersWithDots) {
                _this.charactersWithDots = false;
                _this.textMaxLength = 3;
                _this.customizeText = _this.customizeText.split('.').join('');         
            }

            var isChar = new RegExp(/^[a-zA-Z]*$/).test(_this.customizeText);
            
            if(_this.customizeText){
                _this.textLength = _this.customizeText.split('.').join('').length;
                _this.customizeText = _this.customizeText.toUpperCase();
            } else {
                _this.textLength = 0;
            }

            _this.formErrorCharValidation = !isChar;
            _this.formErrorMessageValidation = false;
            _this.showCharactersWithDotsError = false; 
            _this.reloadCanvas();
        }

        _this.textDateChange = function () {
            var onlyNumbers = /^[0-9.]*$/.test(_this.customizeTextDate);
            var textoSinCaracteresEspeciales = _this.customizeTextDate.replace(/[^\w\s]/gi, '');

            if (!onlyNumbers) {
                _this.formErrorDateOnlyNumbers = true;
            } else {
                _this.formErrorDateOnlyNumbers = false;
            }

            var isNotBackSpace =
                _this.oldCustomizeTextDate.length !== 6 && _this.oldCustomizeTextDate.length !== 3;

            if (
                _this.customizeTextDate.length > 5 &&
                _this.customizeTextDate.split('.').length === 2
            ) {
                var lastString = _this.customizeTextDate.substr(_this.customizeTextDate.length - 1);
                _this.customizeTextDate = _this.customizeTextDate.substring(
                    0,
                    _this.customizeTextDate.length - 1
                );
                _this.customizeTextDate = _this.customizeTextDate + '.' + lastString;
            }

            if (
                _this.customizeTextDate.length > 2 &&
                _this.customizeTextDate.split('.').length === 1
            ) {
                var lastString = _this.customizeTextDate.substr(_this.customizeTextDate.length - 1);
                _this.customizeTextDate = _this.customizeTextDate.substring(
                    0,
                    _this.customizeTextDate.length - 1
                );
                _this.customizeTextDate = _this.customizeTextDate =
                    _this.customizeTextDate + '.' + lastString;
            }
            if (
                (_this.customizeTextDate.length === 2 || _this.customizeTextDate.length === 5) &&
                isNotBackSpace
            ) {
                _this.customizeTextDate = _this.customizeTextDate + '.';
            }
            _this.formErrorDateValidation = false;
            _this.oldCustomizeTextDate = _this.customizeTextDate;
            var dateWhitoutDots = _this.oldCustomizeTextDate.replace(/[^\w\s]/gi, '');
            _this.textDateLength = dateWhitoutDots.length;
        }

        _this.separateWithDots = function() {
            if(_this.charactersWithDots) {
                
                _this.textMaxLength = 6;

                if(_this.customizeText) {
                    _this.customizeText = _this.customizeText.split('').join('.') + '.';
                } else {
                    _this.showCharactersWithDotsError = true;
                }                  
            } else {
                _this.showCharactersWithDotsError = false;   
                
                _this.textMaxLength = 3;

                if(_this.customizeText) {                    
                    _this.customizeText = _this.customizeText.split('.').join('');
                }
            }
            _this.reloadCanvas();    
        }

        _this.reloadCanvas = function () {
            var position;
            if(_this.customizeText) {
                _this.validateText();
            }
            if(_this.activeArea.align === 'center'){
                position = _this.activeArea.left -4.6 + '%';
            } else {
                position = _this.activeArea.left + '%';
            }
            _this.positionCanvas ={ 
                'top': _this.activeArea.top + '%',
                'left': position,
                'height': _this.activeArea.height + '%',
                'color': _this.activeColor.hex,
                'text-align': _this.activeArea.align,
                'opacity': _this.activeColor.name == 'ENGRAVED' ? '.3' : '1'
            };
        };
        

        _this.setImage = function () {
            var promises = [];
            _.each(_this.productCustomizations.areas, function(area) {
                area.image.akamaiUrl = itxAkamaiSvc.useAkamaiImage(area.image.url, _this.widthImg);
                _.concat(promises, $http.get(area.image.akamaiUrl));
            })
            $q.all(promises)
            .then(function() {
                _this.reloadCanvas();
                _this.loading = false;
            })
        };

        _this.addToCart = function() {   

            if (_this.tabInitial) {
                if(_this.customizeText && _this.validateText() && !_this.formErrorCharValidation){
                    _this.product.customization = {
                        'datatype': _this.productCustomizations.type,
                        'text': _this.customizeText.toUpperCase(),
                        'areaId': _this.activeArea.id,
                        'colorId': _this.activeColor.id,
                        'typographyId': _this.activeFont.id
                    };
    
                    ItxShopCartFct.addToCart(
                        _this.product,
                        _this.product.activeDetail.colors[_this.product.state.selectedColorIndex],
                        _this.product.state.selectedSize,
                        null,
                        true
                    ).then(function() {
                        if(ngDialog){
                            ngDialog.close();
                        }
                    });
                } else {
                    _this.formErrorMessage = true;
                }
            } else {
                _this.validateTextData();
                if (
                    _this.customizeTextDate &&
                    !_this.formErrorDateValidation &&
                    !_this.formErrorDateOnlyNumbers
                ) {
                    _this.product.customization = {
                        'datatype': _this.productCustomizations.type,
                        'text': _this.customizeTextDate.toUpperCase(),
                        'areaId': _this.activeArea.id,
                        'colorId': _this.activeColor.id,
                        'typographyId': _this.activeFont.id
                    };
    
                    ItxShopCartFct.addToCart(
                        _this.product,
                        _this.product.activeDetail.colors[_this.product.state.selectedColorIndex],
                        _this.product.state.selectedSize,
                        null,
                        true
                    ).then(function() {
                        if(ngDialog){
                            ngDialog.close();
                        }
                    });
                } else {
                    _this.formErrorDateValidation = true;
                }
            }
        };
        
        _this.validateText = function () {
            if(_this.customizeText){
                if(_this.blacklist[' '+_this.customizeText] || _this.blacklist[_this.customizeText]){
                    _this.formErrorMessageValidation = true;
                    return false;
                } else {
                    _this.formErrorMessageValidation = false;
                    return true;
                }
            } else {
                return false;
            }
        };

        _this.validateTextData = function () {
            var validationDateFormat = /^(\d{2})\.(\d{2})\.(\d{2})$/.test(_this.customizeTextDate);

            _this.formErrorDateValidation = !validationDateFormat;
        }

        _this.isErrorValidate = function () {
            return (_this.formErrorMessage || _this.showCharactersWithDotsError) && !_this.customizeText;
        };

        _this.isErrorValidateBlacklist = function () {
            return _this.formErrorMessageValidation && _this.customizeText;
        };

        // Función para obtener los nombres de los colores traducidos
        _this.getColors = function(color) {
            if (!color){
                return;
            }
            return ItxTranslateSvc.translateCms(color.replace(' ', '_'));

        };

        _this.setCurrentTab = function (tab) {
            if (tab === 'initial') {
                _this.tabInitial = true;
                _this.tabDate = false;
                _this.customizeTextDate = '';
                _this.oldCustomizeTextDate = '';
                _this.formErrorDateOnlyNumbers = false;
                _this.formErrorDateValidation = false;
            } else {
                _this.tabInitial = false;
                _this.tabDate = true;
                _this.charactersWithDots = false;
                _this.customizeText = '';
                _this.formErrorCharValidation = false;
                _this.formErrorMessageValidation = false;
                _this.showCharactersWithDotsError = false;
            }
        };
    }

})();